import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import CampHeader from '../../header/CampHeader';
import { Container, Image, Spinner } from 'react-bootstrap';
import profilePicture from '../../../assets/profile/default-profile-guardian.svg';
import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft';
import { BsCheck } from '@react-icons/all-files/bs/BsCheck';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import { treehouseViewModel } from '../../common/treehouse.view.model';
import InfiniteScroll from 'react-infinite-scroller';
import verfiedIcon from '../../../assets/icon/Verified-badge.svg';
import unVerfiedIcon from '../../../assets/icon/Unverified.svg';
import { EXPERT_ROUTE } from '../../../constants/routes.constants';

const AddMoreTreehoses = () => {
  const history = useHistory();
  const _PAGE_LIMIT = 9;
  const { dependent, fetchAPI } = useAuth();
  const [partners, setPartners] = useState([]);
  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });
  const [selectedTreehouses, setSelectedTreehouses] = useState([]);
  const pageRedirect = () => {
    history.goBack();
  }

  const getSubscribedTreehouses = () => {
    // treehouseViewModel.getSubscribedTreehouses().then((res) => {
    treehouseViewModel.getSubscribedCampMasters(dependent?.id).then((res) => {
      setSelectedTreehouses(res.map(item => item.id))
    }).catch((err) => { });
  }

  const getAllTreehouses = () => {
    const previousFeedList = partners;
    fetchAPI(treehouseViewModel.getAllTreehouses, query, previousFeedList).then((res) => {
      ReactDOM.unstable_batchedUpdates(() => {
        setPartners(res.list)
        setQuery(res.query);
      })
    }).catch((err) => { console.log(err) });
  }

  const showSelected = (id) => {
    if (selectedTreehouses.indexOf(id) != -1) {
      return true;
    }
    else {
      return false;
    }
  }

  const setTreehouseForAdd = (data) => {
    // let params = {
    //   treehouse_id: data
    // };
    if (selectedTreehouses.indexOf(data) != -1) {
      setSelectedTreehouses(selectedTreehouses.filter(item => item != data));
      // params["type"] = "remove";
      fetchAPI(treehouseViewModel.unSubscribeTreehouse, data)
        .then((res) => { })
        .catch((err) => { });
    }
    else {
      setSelectedTreehouses([...selectedTreehouses, data]);
      // params["type"] = "add";
      fetchAPI(treehouseViewModel.subscribeTreehouse, data)
        .then((res) => { })
        .catch((err) => { });
    }
  }

  useEffect(() => {
    // getPartnersList();
    getSubscribedTreehouses();
    // getAllTreehouses();
  }, []);

  const onTreehouseClick = (data) => {
    let id = data?.slug ? data?.slug : data?.id
    history.push({
      pathname: `${EXPERT_ROUTE}/${id}`,
      state: {
        type: data?.slug ? 'slug' : 'id'
      }
    })
  }

  return (
    <>
      {dependent && <CampHeader />}
      <div className="add-more-branches add-more-treehouses">
        <span className="back-btn" onClick={pageRedirect}><FiChevronLeft /></span>
        <Container>
          <div className="add-more-branches-inner add-more-treehouses-inner">
            <h1>Subscribe to experts based on your interests!</h1>
            <h4>
              Discover Independent Experts, who like the same interests as you, <span className='text-style'>{dependent && dependent.first_name}!</span> Subscribe to receive challenges from them, and meet other kids!
            </h4>
            <p>Subscribe to an expert:</p>
            <div className="treehouses-list">
              <ul>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={getAllTreehouses}
                  hasMore={query.has_more}
                  threshold={150}
                  className="home-feed-spinner-wrapper"
                  loader={
                    <Spinner
                      key={0}
                      className="home-feed-spinner"
                      animation="border"
                      variant="info"
                    />
                  }
                >
                  {partners.map((item, key) => (
                    <li key={key}>
                      <div className="treehouese-logo-name" role='button' onClick={() => onTreehouseClick(item)}>
                        <div className="treehouese-logo-wrapper">
                          <div className="treehouese-logo">
                            <img src={item.picture_url ? item.picture_url : profilePicture} alt="" />
                          </div>
                          <span className="check-patch">
                            <Image src={item?.is_verified ? verfiedIcon : unVerfiedIcon} className='green-tick' />
                            </span>
                        </div>
                        <h4 className="treehouese-name">{`${item?.first_name} ${item?.last_name}`}</h4>
                      </div>
                      <div className="subsribe-btn">
                        <button className={`btn-outline ${showSelected(item.id) && "tree-selected"}`} onClick={() => setTreehouseForAdd(item.id)}>{showSelected(item.id) ? <> <span className="subscribed"><BsCheck /></span> Subscribed </> : "Subscribe"}  </button>
                      </div>
                    </li>
                  ))}
                </InfiniteScroll>
              </ul>
            </div>
          </div>
        </Container>
      </div>

    </>
  )
}

export default AddMoreTreehoses